import React from 'react';

interface Props {
  buttonName: string;
}

export const UsTerms: React.FC<Props> = (props) => {
  return (
    <p className="text-gray-light">
      By clicking &quot;{props.buttonName}&quot;, you agree to our{' '}
      <a href="/terms" target="_blank">
        Terms of Use
      </a>{' '}
      and{' '}
      <a href="/privacy" target="_blank">
        Privacy Policy.
      </a>
    </p>
  );
};

export default UsTerms;
